// Where to go after signing in: a path on this site only (not //other.site or an absolute URL), never the sign in
// page itself
export function safeNext(next) {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\') || next.startsWith('/login')) {
    return '/';
  }
  return next;
}

// The sign in page, returning to `next` afterwards
export function loginUrl(next) {
  const target = safeNext(next);
  return target === '/' ? '/login' : `/login?next=${encodeURIComponent(target)}`;
}
